/* eslint-disable react-hooks/rules-of-hooks */
import { useEffect, useState } from 'react';
export var useMediaQuery = mediaQuery => {
  if (typeof window === 'undefined' || !('matchMedia' in window)) {
    return null;
  }

  var [isVerified, setIsVerified] = useState(window.matchMedia(mediaQuery).matches);
  useEffect(() => {
    var mediaQueryList = window.matchMedia(mediaQuery);

    var documentChangeHandler = () => setIsVerified(mediaQueryList.matches);

    if ('addEventListener' in mediaQueryList) {
      mediaQueryList.addEventListener('change', documentChangeHandler);
    } else if ('addListener' in mediaQueryList) {
      // nosonar
      mediaQueryList.addListener(documentChangeHandler);
    }

    documentChangeHandler();
    return () => {
      if ('removeEventListener' in mediaQueryList) {
        mediaQueryList.removeEventListener('change', documentChangeHandler);
      } else if ('removeListener' in mediaQueryList) {
        // nosonar
        mediaQueryList.removeListener(documentChangeHandler);
      }
    };
  }, [mediaQuery]);
  return isVerified;
};
export var useMinWidth = width => {
  return useMediaQuery("(min-width: " + width + ")");
};
export var useMaxWidth = width => {
  return useMediaQuery("(max-width: " + width + ")");
};
//# sourceMappingURL=useMediaQuery.js.map